import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

import SplitText from "gsap/dist/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

document.querySelectorAll(".design-philosophy").forEach((el) => {
	let content_el = el.querySelector(".js-sticky-content");

	const bg = el.querySelector(".js-background");

	const step_titles = el.querySelectorAll(".js-step-titles");

	const steps = step_titles.length;

	const content = el.querySelectorAll(".step-container");

	const progress_counter = el.querySelector(".js-step-progress");

	const text_outer_el = el.querySelector(".js-text-outer-container");

	const mobile_headings_el = el.querySelector(".js-mobile-titles-container");

	const splitContent = [];

	let activeStep = 0,
		previousStep = 0;

	const animateContent = () => {
		const tags = content[activeStep].querySelectorAll(".js-tag");

		const lines = splitContent[activeStep].lines;

		gsap.fromTo(
			lines,
			{
				y: "-100%",
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				stagger: 0.025,
				delay: 0.1,
			},
		);

		gsap.fromTo(
			tags,
			{
				y: 10,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				delay: lines.length * 0.1,
				stagger: 0.15,
			},
		);
	};

	content.forEach((el, index) => {
		let split = SplitText.create(el.querySelectorAll(".split p"), {
			type: "words,lines",
			linesClass: "line",
			autoSplit: true,
			mask: "lines",
			preserveWhitespace: true,
		});

		splitContent.push(split);
	});

	// animate in initial step, yep

	gsap.delayedCall(0.5, () => {
		content[activeStep].classList.add("active");

		animateContent(0);

		if (window.matchMedia("(max-width: 768px)").matches) {
			gsap.to(text_outer_el, {
				height: content[activeStep].offsetHeight + "px",
			});
		}
	});

	ScrollTrigger.create({
		trigger: el,
		start: "top top",
		end: "bottom bottom",
		onUpdate: (self) => {
			bg.style.transform = `translateY(${-6 * self.progress.toFixed(3)}rem)`;

			activeStep = Math.min(Math.floor(self.progress * steps), steps - 1); // 0 to 4

			// items opacity

			if (activeStep !== previousStep) {
				// console.log("animate animate");

				previousStep = activeStep;

				// timelines[activeStep].restart();

				animateContent();

				content.forEach((contentItem) => {
					contentItem.classList.remove("active");
				});

				content[activeStep].classList.add("active");

				// double check if this what we need
				// probably need on desktop as well?
				if (window.matchMedia("(max-width: 768px)").matches) {
					gsap.to(text_outer_el, {
						height: content[activeStep].offsetHeight + "px",
					});
				}

				gsap.to(progress_counter, {
					y: -parseFloat(activeStep * (100 / step_titles.length)) + "%",
				});

				// mobile headings progress

				gsap.to(mobile_headings_el, {
					y: -parseFloat(activeStep * (100 / step_titles.length)) + "%",
				});

				// titles

				step_titles.forEach((title, index) => {
					title.classList.add("opacity-30");

					if (index === activeStep) {
						title.classList.remove("opacity-30");
					}
				});
			}
		},
	});

	window.splitContent = splitContent;
});
